import React from "react";
import styles from "./styles.module.css";
interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}
export default function Checkbox({
  checked,
  onChange,
  label,
  disabled = false,
}: CheckboxProps) {
  return (
    <label className={styles.checkboxContainer}>
      <input
        type="checkbox"
        role="switch"
        aria-label={label}
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        className={styles.checkbox}
      />
      <span className={styles.track} aria-hidden="true">
        <span />
      </span>
    </label>
  );
}
